<template>
  <template v-if="!isSSR">
    <slot />
  </template>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-facing-decorator';
import _isSSR from '@/_base/isSSR';

@Component
export default class NoSSR extends Vue {
  get isSSR(): boolean {
    return _isSSR;
  }
}
</script>
